var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-v1" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "today-info", attrs: { xs: 24, sm: 24, lg: 6 } },
            _vm._l(_vm.cardInfo, function(info, i) {
              return _c("CardInfo", {
                key: i,
                staticClass: "card-style load-up",
                attrs: { info: info }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, lg: 18 } },
            [
              _c("el-row", [
                !_vm.loading
                  ? _c(
                      "div",
                      { staticClass: "chart-wrapper load-up first-chart" },
                      [
                        _c("div", { staticClass: "chart-title" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("dashboard.lineChartTitle")) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.sevenDaysNotEmpty
                          ? _c("line-chart", {
                              ref: "lineChart",
                              attrs: {
                                "chart-label": _vm.lineGraphLabel,
                                "chart-data": _vm.sevenDays
                              }
                            })
                          : _c("div", { staticClass: "no-data" }, [
                              _vm._v(_vm._s(_vm.$t("common.noData")))
                            ])
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("el-row", [
                !_vm.loading
                  ? _c(
                      "div",
                      { staticClass: "chart-wrapper load-up suppress" },
                      [
                        _c("div", { staticClass: "chart-title" }, [
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("dashboard.top5PayCurrency")))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.channelLabels.length
                          ? _c("bar-chart", {
                              ref: "barChart",
                              attrs: {
                                isPercent: true,
                                labels: _vm.channelLabels,
                                values: _vm.channelValues,
                                placeholder: _vm.$t("dashboard.payAmount"),
                                barColor: _vm.sevenDaysColor
                              }
                            })
                          : _c("div", { staticClass: "no-data" }, [
                              _vm._v(_vm._s(_vm.$t("common.noData")))
                            ])
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "tenInfo", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, lg: 12 } },
            [
              _c("div", { staticClass: "heading" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("dashboard.top10SmsCount")) +
                    "\n          "
                ),
                _vm.topOrgs[0]
                  ? _c("span", { staticClass: "title-date" }, [
                      _vm._v(
                        "[" +
                          _vm._s(
                            _vm.topOrgs[0].date ? _vm.topOrgs[0].date : ""
                          ) +
                          "]"
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.smsCountValues.length
                ? _c("pie-chart", {
                    ref: "pieChart",
                    attrs: {
                      values: _vm.smsCountValues,
                      placeholder: _vm.$t("dashboard.top10SmsCountTotal")
                    }
                  })
                : _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "property" }, [
                      _c("div", { staticClass: "card-style load-up" }, [
                        _c("div", { staticClass: "wrapper no-data-label" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("common.noData")) +
                                "\n                "
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, lg: 12 } },
            [
              _c("div", { staticClass: "heading" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("dashboard.top10Agent")) +
                    "\n          "
                ),
                _vm.topAgents[0]
                  ? _c("span", { staticClass: "title-date" }, [
                      _vm._v(
                        "[" +
                          _vm._s(
                            _vm.topAgents[0].date ? _vm.topAgents[0].date : ""
                          ) +
                          "]"
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.agentsValues.length
                ? _c("pie-chart", {
                    ref: "barChart",
                    attrs: {
                      values: _vm.agentsValues,
                      placeholder: _vm.$t("dashboard.top10SmsCountTotal")
                    }
                  })
                : _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "property" }, [
                      _c("div", { staticClass: "card-style load-up" }, [
                        _c("div", { staticClass: "wrapper no-data-label" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("common.noData")) +
                                "\n                "
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, lg: 24 } },
            [
              _c("div", { staticClass: "heading" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("dashboard.top10PaymentYesterday")) +
                    "\n          "
                ),
                _vm.topAgents[0]
                  ? _c("div", { staticClass: "title-date" }, [
                      _vm._v(
                        "\n            [" +
                          _vm._s(
                            _vm.topAgents[0].date ? _vm.topAgents[0].date : ""
                          ) +
                          "]\n          "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.paymentYesterdayLabels.length
                ? _c("bar-chart", {
                    ref: "barChart",
                    attrs: {
                      isPercent: false,
                      labels: _vm.paymentYesterdayLabels,
                      values: _vm.paymentYesterdayValues,
                      placeholder: _vm.$t("dashboard.top10SmsCountTotal"),
                      barColor: _vm.paymentColor
                    }
                  })
                : _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "property" }, [
                      _c("div", { staticClass: "card-style load-up" }, [
                        _c("div", { staticClass: "wrapper no-data-label" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("common.noData")) +
                                "\n                "
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }